import React from "react";
import { bemClassesFromModifiers } from "../../../constants/misc";

function SrollSpyListItem(props) {
  const { modifiers, title, onClick, elementId } = props;

  return (
    <a href={elementId} onClick={onClick}>
      <li
        className={bemClassesFromModifiers(
          "scrollspy__list-element",
          modifiers
        )}
      >
        {title}
      </li>
    </a>
  );
}

export default SrollSpyListItem;
